import { render, staticRenderFns } from "./MenuPackage.vue?vue&type=template&id=3b2b8d83&scoped=true&"
import script from "./MenuPackage.vue?vue&type=script&lang=js&"
export * from "./MenuPackage.vue?vue&type=script&lang=js&"
import style0 from "./MenuPackage.vue?vue&type=style&index=0&id=3b2b8d83&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b2b8d83",
  null
  
)

export default component.exports